export default class LeadSource {
  id?: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): LeadSource {
    return new LeadSource(obj || {});
  }

  public static ofList(obj: any[]): LeadSource[] {
    return obj.map(this.of);
  }
}
